<template>
  <div class="ddlb-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.ordernum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    fixed
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF" v-if="scope.row.produnum!==null&&scope.row.produnum!==''&&scope.row.produnum!==undefined">{{scope.row.produnum}}</span>
                      <span style="font-weight: 500;color:#999999" v-if="scope.row.produnum===null||scope.row.produnum===''||scope.row.produnum===undefined">N/A</span>
                    </template>
                  </el-table-column>
<!--                  <el-table-column-->
<!--                    label="经销商"-->
<!--                    width="120"-->
<!--                    show-overflow-tooltip>-->
<!--                    <template slot-scope="scope">-->
<!--                      <span><i class="el-icon-user"></i> {{scope.row.delname}}</span>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                  <el-table-column
                    label="订单类型"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.type===0">正单</span>
                      <span v-if="scope.row.type===1">客改单</span>
                      <span v-if="scope.row.type===2">增补单</span>
                      <span v-if="scope.row.type===3">色板单</span>
                      <span v-if="scope.row.type===4">售后单</span>
                    </template>
                  </el-table-column>
<!--                  <el-table-column-->
<!--                    label="品牌"-->
<!--                    width="130"-->
<!--                    show-overflow-tooltip>-->
<!--                    <template slot-scope="scope">-->
<!--                      <span style="color:#99a9bf">品牌：</span>-->
<!--                      <span>{{scope.row.brandname}}</span>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                  <el-table-column
                    label="上次操作时间"
                    min-width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
<!--                  <el-table-column-->
<!--                    label="详细地址"-->
<!--                    min-width="200"-->
<!--                    show-overflow-tooltip>-->
<!--                    <template slot-scope="scope">-->
<!--                      <span><i class="el-icon-location-outline"></i> {{scope.row.address}}</span>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
<!--                  <el-table-column-->
<!--                    label="当前状态"-->
<!--                    fixed="right"-->
<!--                    width="100"-->
<!--                    show-overflow-tooltip>-->
<!--                    <template slot-scope="scope">-->
<!--                      &nbsp;-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===2" type="danger">售后驳回</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===3" type="danger">评估驳回</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===4" type="danger">确认驳回</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===5" type="danger">报价驳回</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===6" type="danger">预付驳回</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===7" type="danger">工厂拒接</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2&&scope.row.dismark===0" type="warning">待接单</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===3" class="tcf-tag-1">售后处理</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===4" class="tcf-tag-5">技术评估</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===5" class="tcf-tag-4">拆单分配</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===6&&scope.row.dismark===0" class="tcf-tag-2">待拆单</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===7&&scope.row.dismark===0" class="tcf-tag-6">订单确认</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===8&&scope.row.dismark===0" class="tcf-tag-3">待报价</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===9&&scope.row.dismark===0" class="tcf-tag-9">预付款</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===10&&scope.row.dismark===0" class="tcf-tag-7">工厂分派</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===11" class="tcf-tag-8">工厂接单</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===12" class="tcf-tag-10">订单排产</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===13" class="tcf-tag-11">订单生产</el-tag>-->
<!--                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===100">已完成</el-tag>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                  <el-table-column
                    width="100"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template>
                      <span style="font-size: 13px;color:#99a9bf">报价详情 <i class="el-icon-d-arrow-right"></i></span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getALLOrderListOfOuter } from '@/api/erp'
import { getBrandList } from '@/api/work'

export default {
  name: 'ddlb',
  computed: {
    user: getUser
  },
  data() {
    return {
      search: '',
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchForm: {
        search: '',
        type: '',
        brandId: ''
      },
      brandList: []
    }
  },
  created() {
    this.getData()
    // this.getBrandList()
  },
  methods: {
    getBrandList() {
      getBrandList().then(response => {
        this.brandList = response.data
      })
    },
    Search() {
      this.currentPage = 1
      this.searchForm.search = this.searchForm.search.trim()
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role,
        type: this.searchForm.type,
        brandId: this.searchForm.brandId
      }
      getALLOrderListOfOuter(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/outer_order_offert_detail/' + row.orderid })
    }
  }
}
</script>

<style lang="scss" scoped>
.ddlb-container {
  .tcf-tag-1{
    background: #E8EDF9;
    border-color: #D0DCF8;
    color: #5F8EFC;
  }
  .tcf-tag-2{
    background: #FCE9F6;
    border-color: #FCD5F0;
    color: #F95BC9;
  }
  .tcf-tag-3{
    background: #ECE3FC;
    border-color: #D6BFFF;
    color: #8D55F9;
  }
  .tcf-tag-4{
    background: #FFEEE6;
    border-color: #FFDECE;
    color: #FE7530;
  }
  .tcf-tag-5{
    background: #E8F5FF;
    border-color: #C7E7FF;
    color: #32A7FF;
  }
  .tcf-tag-6{
    background: #EEFCFE;
    border-color: #D6F7FC;
    color: #72B5C1;
  }
  .tcf-tag-7{
    background: #F9FBF0;
    border-color: #E3EBC1;
    color: #B1BF75;
  }
  .tcf-tag-8{
     background: #F9ECD7;
     border-color: #F4CF97;
     color: #C5892E;
   }
  .tcf-tag-9{
    background: #EEF1F7;
    border-color: #BBC7DA;
    color: #7A869A;
  }
  .tcf-tag-10{
    background: #E2F5F2;
    border-color: #CAF4ED;
    color: #419488;
  }
  .tcf-tag-11{
    background: #F5F7FE;
    border-color: #C4CBE1;
    color: #828EB7;
  }
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
